// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// Licensed under the Amazon Software License
// http://aws.amazon.com/asl/

const localStorageKeys = {
  'auth0ExpiresAt': 'app_auth0_expires_at',
  'vptIdToken': 'app_vpt_id_token',
  'auth0AccessToken': 'app_auth0_access_token',
  'auth0IdToken': 'app_auth0_id_token',
  'selectedAffiliationId': 'app_affiliation_id',
  'auth0UserAvatarUrl': 'app_auth0_avatar'
};

export {
  localStorageKeys
};